<rappider-modal *ngIf="isEditModalVisible"
                title="
                Edit
                Form
                Config"
                [visible]="isEditModalVisible"
                [bodyStyle]="modalBodyStyle"
                [fullScreen]="true"
                okText="Save Form Config"
                cancelText="Cancel"
                [footer]="formBuilderModalFooter"
                (okClick)="onFormConfigSave()"
                (cancelClick)="onCancel()">
  <div *ngIf="tempValue"
      class="form-builder"
      style="height: 100%;">
      <as-split direction="horizontal"
                gutterSize="10">

        <as-split-area [size]="20"
                       [minSize]="20"
                       [maxSize]="50">
          <rappider-form-builder-menu style="width: 100%;"
                                      [formItems]="formItems"
                                      (formItemSelected)="onFormItemSelected($event)"></rappider-form-builder-menu>

      </as-split-area>

      <as-split-area [size]="45"
                     [minSize]="30"
                     [maxSize]="70">
        <div class="preview-wrapper">
          <h6>Preview</h6>
          <rappider-divider></rappider-divider>
          <div class="form-builder-section-border form-builder-preview">
            <rappider-form-builder-renderer [(ngModel)]="tempValue.items"
                                            [config]="tempValue"
                                            [scrollToLastItem]="scrollToLastItem"
                                            [autoSelectedFormItem]="autoSelectedFormItem"
                                            (selectItem)="onSelectItem($event)"
                                            (scrollToLastItemEmit)="onScrollToLastItemEmit($event)"
                                            (ngModelChange)="onItemsChange()"></rappider-form-builder-renderer>
          </div>
        </div>
      </as-split-area>
      <as-split-area [size]="35"
                     [minSize]="10"
                     [maxSize]="50">
        <div class="settings-wrapper">
          <div class="settings-and-edit-form-json-data-button-wrapper">
            <div class="settings-and-edit-form-json-data-button">
              <h6>Settings</h6>
              <rappider-button text="Edit Form JSON Data"
                               [icon]="{name: 'fa-solid fa-brackets-curly'}"
                               (click)="openJsonEditorModal()">
                </rappider-button>
            </div>
            <rappider-divider></rappider-divider>
          </div>
          <nz-tabset nzType="card"
                      [nzSelectedIndex]="selectedIndex"
                      class="form-builder-section-border"
                      (nzSelectedIndexChange)="selectedTabIndexChange($event)">
              <nz-tab [nzTitle]="titleTemplateSettings">
                <ng-template #titleTemplateSettings>
                  <rappider-icon [name]="'fa-gear fa-regular'"
                  nz-tooltip
                  nzTooltipTitle="Form Settings"></rappider-icon>
                                  {{selectedIndex === 0 ? 'Form Settings' : ''}}
                </ng-template>
                <div class="form-control-area">
                  <rappider-form-builder-input [(ngModel)]="tempValue.items"
                                              [selectedItem]="selectedItem"
                                              [itemToAdd]="itemToAdd"
                                              (formItemSelected)="onFormItemSelected($event)"
                                              (scrollToLastItem)="onScrollToLastItem($event)"
                                              (autoSelectFormItem)="onAutoSelectFormItem($event)"
                                              (ngModelChange)="onItemsChange()">
                  </rappider-form-builder-input>
                </div>
              </nz-tab>
              <nz-tab [nzTitle]="titleTemplateFormSettings">
                <ng-template #titleTemplateFormSettings>
                  <rappider-icon [name]="'fa-file-lines fa-regular'"
                  nz-tooltip
                  nzTooltipTitle="Settings"></rappider-icon>
                                  {{selectedIndex === 1 ? 'Settings' : ''}}
                </ng-template>
                  <div class="section-title-wrapper">
                    <rappider-heading [type]="'h4'"
                                      [content]="'Form Settings'"></rappider-heading>
                    <rappider-divider></rappider-divider>
                  </div>

                  <div class="form-settings-wrapper">
                    <!-- <div class="form-control-area">
                      <div class="label">
                        <span>
                          <b>
                            Form Title:
                          </b>
                        </span>
                      </div>
                       <rappider-textbox [(ngModel)]="tempValue.formTitle"
                                        (ngModelChange)="onItemsChange()"></rappider-textbox>
                    </div>
                    <div class="form-control-area">
                      <div class="label">
                        <span>
                          <b>
                            Form Title Heading Level:
                          </b>
                        </span>
                      </div>
                       <nz-select [(ngModel)]="tempValue.formTitleHeading"
                                 [nzMaxTagCount]="0"
                                 nzMode="default"
                                 (ngModelChange)="onItemsChange()">
                        <nz-option *ngFor="let config of headingConfig"
                                  [nzLabel]="config.key | translate"
                                  [nzValue]="config.value"></nz-option>
                      </nz-select>
                    </div> -->
                    <div class="form-control-area">
                      <div class="label">
                        <span>
                          <b>
                            Form Layout:
                          </b>
                        </span>
                      </div>
                      <rappider-select [options]="formLayoutOptions"
                                      [(ngModel)]="tempValue.formLayout"
                                      [settings]="SINGLE_SELECT_SETTINGS"
                                      (ngModelChange)="onItemsChange()"></rappider-select>
                    </div>
                    <div class="form-control-area">
                      <div class="label">
                        <span>
                          <b>
                            Input Change Reaction:
                          </b>
                        </span>
                      </div>
                      <rappider-select [options]="inputChangeReactions"
                                      [(ngModel)]="tempValue.inputChangeReaction"
                                      [settings]="SINGLE_SELECT_SETTINGS"
                                      (ngModelChange)="onItemsChange()"></rappider-select>
                    </div>
                  </div>
                  <div class="section-title-wrapper">
                    <rappider-heading [type]="'h4'"
                                      [content]="'Form Validators'"></rappider-heading>
                    <rappider-divider></rappider-divider>
                  </div>
                  <div class="form-settings-wrapper">
                    <div class="form-control-area">
                      <div class="label">
                        <span>
                          <b>
                            Validators:
                          </b>
                        </span>
                      </div>
                      <div>
                        <rappider-json-array [(ngModel)]="tempValue.validators"></rappider-json-array>
                      </div>
                    </div>
                  </div>
                  <div class="section-title-wrapper">
                    <rappider-heading [type]="'h4'"
                                      [content]="'Submit Button Settings'"></rappider-heading>
                    <rappider-divider></rappider-divider>
                  </div>
                  <div class="form-settings-wrapper">
                    <div class="form-control-area">
                      <div class="label">
                        <span>
                          <b>
                            Text:
                          </b>
                        </span>
                      </div>
                      <rappider-textbox [(ngModel)]="tempValue.submitButton.text"
                                        (ngModelChange)="onItemsChange()"></rappider-textbox>
                    </div>
                    <div class="form-control-area">
                      <div class="label">
                        <span>
                          <b>
                            Size:
                          </b>
                        </span>
                      </div>
                      <rappider-select [(ngModel)]="tempValue.submitButton.size"
                                      [options]="buttonSizeSelectOptions"
                                      (ngModelChange)="onItemsChange()"></rappider-select>
                    </div>
                    <div class="form-control-area">
                      <div class="label">
                        <span>
                          <b>
                            Type:
                          </b>
                        </span>
                      </div>
                      <rappider-select [(ngModel)]="tempValue.submitButton.type"
                                      [options]="buttonTypeSelectOptions"
                                      (ngModelChange)="onItemsChange()"></rappider-select>
                    </div>
                    <div class="form-control-area">
                      <div class="label">
                        <span>
                          <b>
                            Block:
                          </b>
                        </span>
                      </div>
                      <rappider-switch [(ngModel)]="tempValue.submitButton.block"
                                      (ngModelChange)="onItemsChange()"></rappider-switch>
                    </div>
                    <div class="form-control-area">
                      <div class="label">
                        <span>
                          <b>
                            Visible:
                          </b>
                        </span>
                      </div>
                      <rappider-switch [(ngModel)]="tempValue.submitButton.visible"
                                      (ngModelChange)="onItemsChange()"></rappider-switch>
                    </div>
                  </div>
              </nz-tab>
            </nz-tabset>
          </div>
      </as-split-area>
    </as-split>
  </div>
</rappider-modal>
<ng-template #formBuilderModalFooter>
  <button nz-button
          (click)="onCancel()">{{'Cancel' | translate}}</button>
  <button nz-button
          nzType="primary"
          (click)="onFormConfigSave()">{{'Save' | translate}}</button>
</ng-template>

<rappider-button text="Edit Form Config"
                (click)="openEditModal()"></rappider-button>

<!-- JSON Editor Modal -->
<rappider-json-editor-modal [data]="tempValue"
                            [title]="'Edit Form JSON Data'"
                            [visible]="isJsonEditorModalVisible"
                            (visibleChange)="onJsonEditorVisibleChange($event)"
                            (dataChange)="onDataChange($event)"></rappider-json-editor-modal>
